export const SPLUNK_LEARNING_OVERVIEW = 'https://learning.splunk.com/learn/lp/80/business-value-tools-tutorials-learning-plan';
export const SPLUNK_LEARNING_FULL = 'https://learning.splunk.com/learn/course/1306/data-source-assessment-dsa-how-to-use-the-ssep-course';
export const SPLUNK_LEARNING_NEW_CUSTOMER = 'https://learning.splunk.com/learn/course/1833/bvc-new-customer-dsa-video-september-2018';


// WEBPACK FOOTER //
// ./src/constants/splunkLearningLinks.js